import { render } from "./Dispute.vue?vue&type=template&id=49b9b9de&scoped=true"
import script from "./Dispute.vue?vue&type=script&lang=js"
export * from "./Dispute.vue?vue&type=script&lang=js"

import "./Dispute.vue?vue&type=style&index=0&id=49b9b9de&lang=less&scoped=true"

import exportComponent from "D:\\pwrd\\gw-future\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b9b9de"]])

export default __exports__